/**
 * Part of starter project.
 *
 * @copyright  Copyright (C) 2021 LYRASOFT.
 * @license    __LICENSE__
 */

import '@regenerator-runtime';
import '@unicorn/unicorn.js';
import { UIBootstrap5 } from '@unicorn/ui/ui-bootstrap5.js?bece4cc7cead0e8a80c2c3c8';

u.use(UIBootstrap5);

export default u;

let recordSwiper = new Swiper('.recordSwiper', {
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
  },
});

const recordModal = document.getElementById('recordModal');
const scaleButton = document.querySelectorAll('.j-scale-button');
const recordModalSwiperWrapper = document.querySelectorAll('.j-modal-swiper-wrapper');

if (recordModal) {
  scaleButton.forEach((button) => {
    button.addEventListener('click', function () {
      let imagesHtml = button.closest('.j-record-swiper-wrapper').querySelector('.j-modal-inner').innerHTML;

      recordModalSwiperWrapper.forEach((wrapper) => {
        wrapper.innerHTML = imagesHtml;
      });
    });
  });

  recordModal.addEventListener('show.bs.modal', () => {
    let recordModalSwiper = new Swiper('.recordModalSwiper', {
      spaceBetween: 12,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesProgress: true,
    });

    let recordModalSwiper2 = new Swiper('.recordModalSwiper2', {
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      thumbs: {
        swiper: recordModalSwiper,
      },
    });
  });
}
